import {Paper as MantinePaper, PaperProps as MantinePaperProps} from "@mantine/core";
import {PropsWithChildren} from "react";

export type PaperProps = Omit<MantinePaperProps, 'children'> & {
  // extended props here
}

export const Paper = (props: PropsWithChildren<PaperProps>) => {
  const {children, ...rest} = props
  return (
    <MantinePaper {...rest}>
      {children}
    </MantinePaper>
  )
}
